<template>
    <div class="error-wrapper">
        <div class="container">
            <ErrorPage403 />
        </div>
    </div>
</template>
<script lang="ts" setup>
import { defineAsyncComponent } from 'vue';
const ErrorPage403 = defineAsyncComponent(
    () => import('@/components/theme/error/Error403.vue'),
);
</script>
